import React, { FunctionComponent, useContext, useMemo } from "react";

import { useParams } from "react-router";
import { createRunRepository } from "../../domain/run/RunRepository";
import { MapContainer, Polyline, TileLayer } from "react-leaflet";
import { Run } from "../../domain/run/Run";
import { LatLng } from "leaflet";
import { createMapService } from "../../domain/map/MapService";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RunnerContext } from "../../context/RunnerContext";
import { useNavigate } from "react-router-dom";
import { Path } from "../shared/Path";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";

export const Detail: FunctionComponent = () => {
  const mapService = createMapService();
  const { runs, setRuns } = useContext(RunnerContext);
  const navigate = useNavigate();

  const { runId } = useParams<string>();
  const runRepository = createRunRepository();
  const run = useMemo(() => {
    return runRepository.getRun(runId!);
  }, [runId]);

  if (!run) return <div>No run found</div>;

  function deleteRun() {
    setRuns(runs.filter((run) => run.runId !== runId));
    navigate(Path.RUNS);
  }

  function formatTimeDelta(startTime: number, endTime: number): string {
    const delta = (endTime - startTime) / 1000;
    const hours: number = Math.floor(delta / 3600);
    const minutes: number = Math.floor((delta % 3600) / 60);
    const seconds: number = Math.floor(delta % 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }

  const centerFromRun = (run: Run): LatLng => {
    const startPoint = run.track.trackPoints[0];
    return new LatLng(startPoint.latitude, startPoint.longitude);
  };

  return (
    <div className={"flex flex-col w-full h-full p-6 dark:text-white gap-6"}>
      <div className={"flex flex-row justify-between items-center gap-2"}>
        <FontAwesomeIcon
          className={"text-xl"}
          onClick={() => navigate(-1)}
          icon={faArrowLeft}
        />
        <p className={"text-2xl font-bold"}>
          Dein Run am {new Date(run.startTime).toLocaleDateString()}
        </p>
        <FontAwesomeIcon
          className={"text-xl"}
          onClick={() => deleteRun()}
          icon={faTrash}
        />
      </div>
      <MapContainer
        className={"w-full h-64 rounded"}
        center={centerFromRun(run)}
        zoom={20}
        dragging={false}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
        />
        <Polyline positions={mapService.track2Polygon(run.track.trackPoints)} />
      </MapContainer>
      <div
        className={
          "rounded dark:bg-slate-900 flex flex-col p-3 gap-1 backdrop-blur-sm"
        }
      >
        <p className={"font-bold text-xl flex flex-row justify-between"}>
          <p>Start:</p>
          <p> {new Date(run.startTime).toLocaleTimeString()}</p>
        </p>
        <p className={"font-bold text-xl flex flex-row justify-between"}>
          <p>Ende:</p>
          <p>{new Date(run.endTime).toLocaleTimeString()}</p>
        </p>
        <p className={"font-bold text-xl flex flex-row justify-between"}>
          <p>Dauer:</p>
          <p>{formatTimeDelta(run.startTime, run.endTime)}</p>
        </p>
        <p className={"font-bold text-xl flex flex-row justify-between"}>
          <p>Länge:</p>
          <p>
            {run.track.distances
              .map((value) => value.distance)
              .reduce((acc, val) => acc + val)
              .toFixed(1) + " km"}
          </p>
        </p>
      </div>
    </div>
  );
};
